export default __webpack_public_path__ + "assets/next.679fe33b.svg";